import styled from 'styled-components';
import NextImage from 'next/image';

import { SimpleButtonQuality } from '@components/formStyles';
export const SetairPromotionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 283px);
  grid-column-gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow-x: scroll;
  }
`;
export const ImageContainer = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;

export const TitleContainer = styled.div`
  position: absolute;
  top: 20px;
  display: flex;
  margin-left: 20px;
  line-height: normal;
`;

export const VerticalIndicator = styled.div`
  width: 6px;
  height: 18px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.palette.coral};
  margin-right: 10px;
`;

export const InfoContainer = styled.div`
  position: absolute;
  bottom: 20px;
  margin-left: 20px;
  line-height: 1.17;
`;

export const Button = styled(SimpleButtonQuality)`
  color: ${({ theme }) => theme.palette.eclipse};
  cursor: pointer;
  border-radius: 8px;
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
`;
export const Image = styled(NextImage)`
  position: relative !important;
  border-radius: 8px;
`;
export const VizeContainer = styled.div`
  display: grid;
  grid-template-columns: 435px 435px;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
  }
`;
